
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M23.4 20.355H3.617V.85A.843.843 0 002.77.013a.843.843 0 00-.848.838v19.504H.848a.843.843 0 00-.848.838c0 .463.38.838.848.838h1.074v1.118c0 .463.38.838.848.838a.843.843 0 00.847-.838v-1.118H23.4a.843.843 0 00.848-.838.843.843 0 00-.848-.838z"}}),_c('path',{attrs:{"d":"M23.937 1.205c-1.14 0-2.063.913-2.063 2.04 0 .544.216 1.038.567 1.403l-3.18 7.692a2.064 2.064 0 00-.854.394l-5.081-2.547.002-.087c0-1.127-.924-2.04-2.063-2.04-1.14 0-2.063.913-2.063 2.04 0 .415.125.801.341 1.123l-1.98 3.062c-1.255-.18-2.363.781-2.363 2.018 0 1.127.924 2.04 2.063 2.04 1.14 0 2.063-.913 2.063-2.04 0-.411-.123-.794-.335-1.115l1.985-3.069c.576.08 1.145-.08 1.587-.434l5.06 2.536c-.066 1.178.882 2.155 2.06 2.155 1.14 0 2.063-.913 2.063-2.04 0-.66-.317-1.247-.81-1.62l3.074-7.433A2.05 2.05 0 0026 3.245c0-1.127-.924-2.04-2.063-2.04z"}})])])
          )
        }
      }
    